<template>
  <div class="start flex flex-wrap -mx-2">
    <div class="w-full">
      <h1 v-if="mode == 'recommend' && !hideHeadline">Einen Anbieter empfehlen</h1>
      <h1 v-if="mode == 'register' && !hideHeadline">Einen Anbieter anmelden</h1>

      <p class="mb-6 text-sm leading-tight text-grey-dark"></p>

      <div v-if="finished" class="mt-8 flex items-center bg-green-heinz text-black text-sm font-bold px-4 py-3" role="alert">
        <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
        <p v-if="mode == 'recommend'">Vielen Dank für deine Empfehlung! Wir werden versuchen den Anbieter zu überzeugen an {{ site.domain }} teilzunehmen.</p>
        <p v-if="mode == 'register'">Vielen Dank für deine Anmeldung! Wir werden dich in Kürze kontaktieren.</p>
      </div>

      <form v-if="!finished" name="review">
        <div class="w-full mb-6">
          <p class="block max-w-md tracking-wide text-grey-darker text-sm font-bold" for="grid-reorder">
            <span v-if="mode == 'recommend'">Du möchtest über uns bei deinem Lieblingsanbieter bestellen aber er ist noch nicht gelistet? Empfiehl uns, gib uns seine Kontaktdaten und wir versuchen unser bestes!</span>
            <span v-if="mode == 'register'">Du möchtest als Anbieter bei uns teilnehmen?<br />Einfach das Formular ausfüllen und wir melden uns schnellstmöglich!</span>
          </p>
        </div>

        <div class="w-full mb-6">
          <label class="block tracking-wide text-grey-darker text-sm font-bold" for="grid-email">
            Deine E-Mail Adresse:
          </label>
          <div class="relative">
            <input type="email" v-model="email" class="max-w-md appearance-none block w-full text-grey-darker border border-green rounded py-3 px-4" id="grid-email"></textarea>
          </div>
        </div>

        <div class="w-full mb-6">
          <label class="block max-w-md tracking-wide text-grey-darker text-sm font-bold" for="grid-comment">
            <span v-if="mode == 'recommend'">Daten des Anbieters (Name und Adresse), die wir benötigen um ihn zu kontaktieren:</span>
            <span v-if="mode == 'register'">Daten deines Anbieters (Name und Adresse), die wir benötigen um dich zu kontaktieren:</span>
          </label>
          <div class="relative">
            <textarea v-model="comment" class="max-w-md appearance-none block w-full h-32 text-grey-darker border border-green rounded py-3 px-4" id="grid-comment"></textarea>
          </div>
        </div>

        <button v-on:click="send" class="max-w-md bg-green-heinz hover:bg-green-heinz-light text-black py-4 px-2 mb-8 w-full rounded">
          <span v-if="mode == 'recommend'">Empfehlung</span>
          <span v-if="mode == 'register'">Anmeldung</span>
          abschließen
        </button>
      </form>
    </div>
  </div>
</template>

<script>
  import endpoints from '../../endpoints'
  import axios from 'axios'

  export default {
    name: 'Recommend',

    data () {
      return {
        finished: false,
        email: '',
        comment: ''
      }
    },

    props: [
      'mode',
      'hideHeadline'
    ],

    methods: {
      send(e) {
        e.preventDefault()
        this.finished = true

        axios.post(endpoints.recommend, {
          'mode': this.mode,
          'email': this.email,
          'comment': this.comment
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/recommend/index.vue